// Dashboard.js

import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import CRM from "./CRM";
// import Analyze from "./Analyze"
import Callhistory from "./Callhistory";
import DoNotDisturb from "./DoNotDisturb";
import WaitingList from "./WaitingList";
import Dashrigmo from "./Dashrigmo";
import Agentscce from "./Agentscce";
import InboundDashboard from "./InboundDashboard";
import InboundCRM from "./InboundCRM";
import Configuration from "./Configuration";

// import ClientSubscriptions from "./ClientSubscriptions";

const Dashboard = () => { 
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [view, setView] = useState("Dashboard");
  const [selectedService, setSelectedService] = useState("Outbound");
  // const [username, setUsername] = useState(localStorage.getItem("username") || "");
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    setUser(storedUser);
  }, []);


  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/";
  };


  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        setView={setView}
        // username={username}
        handleLogout={handleLogout}
        user={user?.name}
        selectedService={selectedService}
      />
      <div className="flex-1 flex flex-col overflow-y-auto">
        <Header
          user={user?.name}
          selectedService={selectedService}
          setSelectedService={setSelectedService}
        />

        {view === "Dashboard" && selectedService === "Outbound" && (
          <Dashrigmo setView={setView} user={user} />
        )}
        {view === "Dashboard" && selectedService === "Inbound" && (
          <InboundDashboard setView={setView} user={user} />
        )}
        {view === "CRM" && selectedService === "Outbound" && <CRM user={user} />}
        {view === "CRM" && selectedService === "Inbound" && <InboundCRM user={user} />}
        {view === "Agents-CCE" && <Agentscce user={user} ></Agentscce>}
        {view === "CallHistory" && <Callhistory user={user} selectedService={selectedService} />}
        {view === "DoNotDisturb" && <DoNotDisturb user={user} />}

        {view === "WaitingList" && <WaitingList user={user}  ></WaitingList>}
        {view === "Configuration" && <Configuration user={user} />}

        {/* {view === "Subscriptions" && <ClientSubscriptions  user={user}></ClientSubscriptions>} */}
      </div>
    </div>
  );
};

export default Dashboard;
